import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TokenService } from '../services/token';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private tokenService = inject(TokenService);
  private router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    const token = this.tokenService.getToken();
    const isAuthenticated = !!token?.accessToken;
    
    // Check if this is a login/auth route
    const isAuthRoute = state.url === '/' || state.url.startsWith('/auth') || state.url === '';
    
    if (isAuthRoute) {
      // For auth routes (login page), redirect authenticated users to meetings
      if (isAuthenticated) {
        return this.router.createUrlTree(['/meeting']);
      }
      // Allow unauthenticated users to access login
      return true;
    } else {
      // For protected routes, require authentication
      if (isAuthenticated) {
        // Validate token is not expired (basic check)
        if (this.isTokenValid(token)) {
          return true;
        } else {
          // Token is expired, clear it and redirect to login
          this.tokenService.clearToken();
          return this.router.createUrlTree(['/']);
        }
      }
      // Redirect unauthenticated users to login
      return this.router.createUrlTree(['/']);
    }
  }

  private isTokenValid(token: any): boolean {
    // Basic token validation - check if token exists and has required fields
    if (!token || !token.accessToken) {
      return false;
    }
    
    // For JWT tokens, we could decode and check expiry, but for now
    // we'll rely on the API to validate the token
    // The interceptor will handle token refresh if needed
    return true;
  }
}
